// react + dependencies
import React from "react";
import { Link } from "react-router-dom";

const PricelistComponent = () => {
  return (
    <>
      <div className="w-full">
        <div className="w-full flex flex-col items-center">
          <div className="w-full my-4" id="rodiny">
            <div className="text-start">
              <h3 className="pb-0 uppercase text-lg font-semibold">
                rodinné / těhotenské / páry
              </h3>
              <p className="pt-2 pb-4 text-lg">1500,-</p>
            </div>
            <div className="text-start">
              <ul className="leading-loose">
                <li>20ks fotografií v el. podobě</li>
                <li>1 hodina focení</li>
                <li>webová galerie pro sdílení fotek</li>
                <li>k dispozici náhledy pro uhašení hladu</li>
                <li>focení probíhá venku nebo u Vás doma</li>
              </ul>
            </div>
          </div>
          <div className="block lg:hidden border w-full border-[var(--cerna)]"></div>
          <div className="w-full my-4" id="svatby">
            <div className="text-start">
              <h3 className="pb-0 uppercase text-lg font-semibold">svatby</h3>
              <p className="pt-2 pb-4 text-lg">ceník na vyžádání</p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full">
        <table class="w-full table-auto ">
          <thead>
            <tr>
              <th>Služba</th>
              <th>Cena</th>
              <th>Poznámka</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Rodinné/Těhotenské/Páry</td>
              <td>1500 Kč</td>
              <td>
                <ul>
                  <li>20ks fotografii v el. pododě</li>
                  <li>1 hodina focení</li>
                  <li>webová galerie pro sdílení fotek</li>
                  <li>k dispozici náhledy pro uhašení hladu</li>
                  <li>venku nebo u Vás doma</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Svatby</td>
              <td>Ceník na vyžádání</td>
              <td>
                <Link to="/kontakt">
                  <button className="btn-primary">Zažádat</button>
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PricelistComponent;
